export default {"src":"/planos/_next/static/media/equifax-phone.b1af011e.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};